import { Backdrop, CircularProgress, Divider, Grid } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Select from '../../../components/Form/Select'
import TextField from '../../../components/Form/TextField'
import { useAuth } from '../../../hooks/auth'
import MvmStatus from '../../../interfaces/MvmStatus'
import MvmApi from '../../../services/MvmApi'
import utilsDate from '../../../utils/Date'
import MvmInvoiceList from '../../Mvm/components/MvmInvoiceList'
import { useStyles } from '../Style'
import MvmShedList from './MvmShedList'

type Props = {
    showSheds: boolean,
    showInvoices: boolean
    clickHandlerCallback?: () => void,
    clickHandlerClose?: () => void
}

interface IFormInput {
    mvmNumber: any;
    cartPlateNumber: string;
    vehicleTypeDescription: string;
    shippingCompanySupplier: string;
    shippingSupplier: string;
    entryConcierge: string;
    presentationPlantDate: string;
    entryAuthorizationDate: string;
    entranceDate: string;
    submitDate: string;
    deliveryWindowDate: string;
    conciergeReleaseDate: string;
    exitDate: string;
    sheds: any;
    invoices: any;
    vehiclePlateNumber: string;
}



const SearchMvmSummary: React.FC<Props> = (props) => {

    const classes = useStyles();
    const { t: tMvm } = useTranslation("Mvm")
    const { user } = useAuth()
    const { t: tGeneral } = useTranslation("General")
    const [loading, setLoading] = useState(false)
    const [mvm, setMvm] = useState<any>(null)
    const { enqueueSnackbar } = useSnackbar()
    const { control, handleSubmit, setValue } = useForm<IFormInput>(
        {
            defaultValues: {
                mvmNumber: {},
                cartPlateNumber: '',
                vehicleTypeDescription: '',
                shippingCompanySupplier: '',
                shippingSupplier: '',
                entryConcierge: '',
                presentationPlantDate: '',
                entryAuthorizationDate: '',
                entranceDate: '',
                submitDate: '',
                deliveryWindowDate: '',
                conciergeReleaseDate: '',
                exitDate: '',
                sheds: [],
                invoices: [],
                vehiclePlateNumber: ''
            }
        })

    function search(data: any) {
        if (data && data.label !== "") {
            setLoading(true);
            setMvm(null)
            MvmApi.getMvmByMvmNumber(data.label, user.company.plantID, ["Sheds", "Invoices"])
                .then(result => {
                    if (result) {
                        setValue("cartPlateNumber", result.cartPlateNumber)
                        setValue("vehiclePlateNumber", result.vehiclePlateNumber)
                        setValue("vehicleTypeDescription", result.vehicleTypeDescription)
                        setValue("shippingCompanySupplier", result.shippingCompanySupplierCorporateName)
                        setValue("shippingSupplier", result.shippingSupplierCorporateName)
                        setValue("entryConcierge", result.conciergeCode)
                        setValue("presentationPlantDate", result.scheduleDate ? `${utilsDate.DateTimeShort(result.scheduleDate)} - ${result.scheduleUser}` : '')
                        setValue("entryAuthorizationDate", result.entryAuthorizationDate ? `${utilsDate.DateTimeShort(result.entryAuthorizationDate)} - ${result.entryAuthorizationUser}` : '')
                        setValue("entranceDate", utilsDate.DateTimeShort(result.entranceDate))
                        setValue("submitDate", utilsDate.DateTimeShort(result.submitDate))
                        setValue("deliveryWindowDate", utilsDate.DateTimeShort(result.deliveryWindowDate))
                        setValue("conciergeReleaseDate", result.conciergeReleaseDate ? `${utilsDate.DateTimeShort(result.conciergeReleaseDate)} - ${result.conciergeReleaseUser}` : '')
                        setValue("exitDate", utilsDate.DateTimeShort(result.exitDate))

                        setValue("sheds", result.sheds)
                        setValue("invoices", result.invoices)

                        setMvm(result)

                    } else {
                        setLoading(false)
                        enqueueSnackbar(tGeneral("objectNotFound"), { variant: 'warning' })
                    }
                }).catch(() => {
                }).finally(() => {
                    setLoading(false);
                })
        }
    }

    const onSubmit = (data: any) => { }

    return (
        <form onSubmit={handleSubmit(onSubmit)} >
            <Divider style={{ marginTop: '10px' }} />
            <Grid container spacing={1} >
                <Grid item xs={2}>
                    <Select
                        label={tMvm('mvmNumber')}
                        name={'mvmNumber'}
                        control={control}
                        searchFunction={(mvmNumber: string) => {
                            if (!mvmNumber || mvmNumber.length !== 8) {
                                return Promise.resolve([])
                            }
                            return MvmApi.searchMvmNumbersNonCountAutocomplete(user.company.companyID, mvmNumber,
                                [MvmStatus.FLAG_STATUS_DRAFT,
                                MvmStatus.FLAG_STATUS_PENDING_ENTRANCE,
                                MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                                MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                                MvmStatus.FLAG_STATUS_PENDING_LOAD])
                        }}
                        onChange={search}
                        style={{ width: "100%", marginRight: 10 }}
                        allowEnterKey={false}
                    />
                </Grid>
                <Backdrop style={{ zIndex: 9999 }} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Grid>
            {mvm == null ? <></> :
                <>
                    <Grid container spacing={1} >
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("cartPlateNumber")}
                                name="cartPlateNumber"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={tMvm("vehicleTypeDescription")}
                                name="vehicleTypeDescription"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("vehiclePlateNumber")}
                                name="vehiclePlateNumber"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} >
                        <Grid item xs={4}>
                            <TextField
                                label={tMvm("shippingCompanySupplier")}
                                name="shippingCompanySupplier"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                label={tMvm("shippingSupplier")}
                                name="shippingSupplier"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("submitDate")}
                                name="submitDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("presentationPlantDate")}
                                name="presentationPlantDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("entryAuthorizationDate")}
                                name="entryAuthorizationDate"
                                value={"12345"}
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("conciergeReleaseDate")}
                                name="conciergeReleaseDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />

                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("entryConcierge")}
                                name="entryConcierge"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("deliveryWindowDate")}
                                name="deliveryWindowDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("entranceDate")}
                                name="entranceDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("exitDate")}
                                name="exitDate"
                                control={control}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }} />
                        </Grid>
                    </Grid>
                    {props.showSheds && (
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <MvmShedList
                                    control={control}
                                    name={"sheds"} />
                            </Grid>
                        </Grid>
                    )}

                    {props.showInvoices && (
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <MvmInvoiceList
                                    control={control}
                                    title={tMvm("invoices")}
                                    name={"invoices"}
                                    allowAdd={false}
                                    allowDelete={false}
                                    Mvm={mvm} />
                            </Grid>
                        </Grid>
                    )}
                </>}
        </form>
    )
}
export default SearchMvmSummary;
